import { api } from '@/services/api'
import { put } from 'redux-saga/effects'
import { updateContactAction } from '../../handles'
import { updateActiveChatAction, updateChatFirebaseAction } from '@/redux/chat/actions'

export function* updateContactSaga(action: ReturnType<typeof updateContactAction.request>) {
  const { id, chatId, dataToUpdate, callback } = action.payload
  try {
    yield api.post('/contacts/update', { id, dataToUpdate })

    if (!chatId) return
    yield put(updateActiveChatAction({ chatName: dataToUpdate.name }))
    yield put(updateChatFirebaseAction.request({ chatId, updateChat: { chatName: dataToUpdate.name } }))

    yield put(updateContactAction.success())
    yield callback?.()
  } catch (error) {
    console.log('updateContactSaga Error', error)
    yield callback?.()
    yield put(updateContactAction.failure())
  }
}
